'use strict';

var $ = require('jquery');
var addSocialShare = require('./addSocialShare.js');

module.exports = {
	init : function() {
		if ($('.__article .text img').length === 0) {
			return;
		}
	
		$('.text img').wrap('<span class="socialSharingContainer"></span>');
		$('.socialSharingContainer').each(function() {
			var $img = $(this).find('img');
			var alignAttr = $img.attr('align');
			var widthAttr = $img.attr('width');
	
			if (alignAttr) {
				$(this).attr('align', alignAttr);
				$img.removeAttr('align');
	
				if (widthAttr) {
					$(this).addClass('socialSharingContainer--setWidth');
				}
			}
		});
	
		$('.socialSharingContainer').hover(function(event) {
			addSocialShare(this, this.querySelector('img').getAttribute('src'), document.querySelector('h1').textContent);
		}, function() {
			// Mouse leave
		});
	}
};
